const MAX_DRIVE_TIME_POLYGON_HOURS = 8;
export const MAX_DRIVE_TIME_POLYGON_SECONDS = MAX_DRIVE_TIME_POLYGON_HOURS * 60 * 60;
